import React from 'react'
import { Menu, Grow } from '@material-ui/core'
import PropTypes from 'prop-types'

import './profileMenu.component.scss'

const menuItems = [
  { key: 'logout', title: 'Logout', icon: 'q4i-logout-2pt' }
]

/**
 * On Logout redirect to login page
 */
const onLogout = (props) => {
  const { auth, history } = props
  auth.logout()
  history.push('/')
}

/**
 * On Menu Item Click
 * @param props
 */
const onClick = (props) => {
  const { key, auth, history, onClose } = props

  if (key === 'logout') {
    onLogout({ auth, history })
  }
  onClose()
}

/**
 * Profile Menu Component
 * @param props
 * @returns {null|*}
 * @constructor
 */
const ProfileMenu = (props) => {
  const { anchorEl, profile, auth, history, onClose } = props

  if (!profile) {
    return null
  }

  const { name } = profile

  return (
    <Menu
      id='header-menu'
      className='header-menu_mask'
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      classes={{ paper: 'header-menu' }}
      elevation={1}
      marginThreshold={0}
      TransitionComponent={Grow}
      style={{ transformOrigin: '0 0 0' }}>
      <div className={'header-menu_profile'}>
        <div className='header-menu_profile-name'>{name}</div>
      </div>

      {menuItems.map((item) => {
        const { key, title, icon } = item
        return (
          <div key={key} className='header-menu_item' onClick={() => onClick({ key, auth, history, onClose })}>
            <i className={`icon ${icon}`} />
            {title}
          </div>
        )
      })}
    </Menu>
  )
}

ProfileMenu.propTypes = {
  profile: PropTypes.object.isRequired,
  history: PropTypes.object,
  auth: PropTypes.object,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired
}

export default ProfileMenu
